import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ApiResponse } from './api.service';
import { CategoryType } from '../enums/app.enums';

export interface CategoryDto {
  categoryId: string;
  category: string;
  parentCategoryId: string | null;
  categoryType: CategoryType;
  categoryTypeName: string;
  parentCategoryName: string | null;
  fullHierarchy?: string | null;
  isDeleted?: boolean;
  gstPercent?: number | null;
}

export interface SaveCategoryRequest {
  categoryId: string;
  category: string;
  parentCategoryId: string | null;
  categoryType: CategoryType;
  gstPercent?: number | null;
}

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private apiService = inject(ApiService);

  getCategories(): Observable<ApiResponse<CategoryDto[]>> {
    return this.apiService.get<CategoryDto[]>('Category/list');
  }

  saveCategory(request: SaveCategoryRequest): Observable<ApiResponse<any>> {
    return this.apiService.post<any>('Category/save', request);
  }

  deleteCategory(categoryId: string): Observable<ApiResponse<any>> {
    return this.apiService.delete<any>(`Category/${categoryId}`);
  }
}
